// Mobile UI chrome: a body.mobile flag plus the segmented tab bars that
// reorganize the menu (Join/Create) and lobby (Players/Setup/Details) screens.
// The same DOM elements serve both layouts — tabs only toggle visibility via
// each screen's data-mtab attribute (see the MOBILE LAYOUT section in style.css).

import { $ } from "./dom.js";

// Phones always; touch tablets up to ~900px. A landscape iPad keeps the
// desktop columns, which fit comfortably there (in-game touch controls are
// governed separately by body.touch).
const MOBILE_MQ = window.matchMedia(
  "(max-width: 760px), (pointer: coarse) and (max-width: 900px)"
);

export const isMobile = (): boolean => MOBILE_MQ.matches;

function selectTab(screen: HTMLElement, tab: string): void {
  screen.dataset.mtab = tab;
  screen.querySelectorAll<HTMLButtonElement>(".m-tab").forEach((b) => {
    b.classList.toggle("active", b.dataset.tab === tab);
  });
}

/** Apply the body flag and wire every tab bar. Call once at startup. */
export function initMobileUI(): void {
  const apply = () => document.body.classList.toggle("mobile", isMobile());
  apply();
  MOBILE_MQ.addEventListener("change", apply);

  document.querySelectorAll<HTMLElement>(".m-tabs").forEach((bar) => {
    const screen = $(bar.dataset.for ?? "");
    selectTab(screen, screen.dataset.mtab ?? "");
    bar.querySelectorAll<HTMLButtonElement>(".m-tab").forEach((btn) => {
      btn.onclick = () => selectTab(screen, btn.dataset.tab ?? "");
    });
  });
}

/**
 * Keep the lobby tabs consistent with the player's role: hosts get Setup,
 * everyone else the read-only Details (the other tab is display:none in CSS).
 * Falls back to Players on lobby entry or when the active tab just vanished
 * because the host role changed hands.
 */
export function syncLobbyTabs(isHost: boolean, entering: boolean): void {
  const lobby = $("lobby");
  lobby.classList.toggle("is-host", isHost);
  const tab = lobby.dataset.mtab;
  if (entering || (tab === "setup" && !isHost) || (tab === "details" && isHost)) {
    selectTab(lobby, "players");
  }
}
